const getBrandLink = ({ brand, isMale }: { brand: string, isMale: boolean }): string => {
  const brandLink   = (brand || '').replace(/\s/g, '-').toLowerCase()
  const productType = isMale ? 'colognes' : 'perfumes'

  return `/${brandLink}-${productType}`
}


export default getBrandLink
